import Icon from "./Icon";
import IconLink from "./IconLink";

export default { Icon, IconLink };
